import {
    ArchitectureType as GeneratedArchitectureTypeBeta,
    HardwareProfile as GeneratedHardwareProfileBeta,
    Pool as GeneratedPoolBeta,
} from 'devcenter-internal-beta';
import {
    HardwareProfile as GeneratedHardwareProfileStable,
    HibernateSupport as GeneratedHibernateSupportStable,
    ImageReference as GeneratedImageReferenceStable,
    LocalAdminStatus as GeneratedLocalAdminStatusStable,
    PoolHealthStatus as GeneratedPoolHealthStatusStable,
    Pool as GeneratedPoolStable,
    SkuName as GeneratedSkuNameStable,
    StorageProfile as GeneratedStorageProfileStable,
} from 'devcenter-internal-stable';
import { UnionMap } from '../../types/union-map';
import { ResourceContract, ResourceProvisioningStateContract } from './resource-manager';

/**
 * Control Plane models
 */

export interface PoolResourceContractProperties {
    machineDefinitionId: string;
    networkSettingsId: string;
    // TODO: see if we can create an enum type for below property in future.
    // FWIW - Control Plane spec doesn't mention possible values... :(
    provisioningState: ResourceProvisioningStateContract;
    sku: {
        name: string;
    };
}

export type PoolResourceContract = ResourceContract<PoolResourceContractProperties>;

/**
 * Data Plane SDK shim models
 */

export type SkuNameContract = GeneratedSkuNameStable;

export const SkuNameContract: UnionMap<SkuNameContract> = {
    general_a_16c64gb1024ssd_v2: 'general_a_16c64gb1024ssd_v2',
    general_a_16c64gb2048ssd_v2: 'general_a_16c64gb2048ssd_v2',
    general_a_16c64gb256ssd_v2: 'general_a_16c64gb256ssd_v2',
    general_a_16c64gb512ssd_v2: 'general_a_16c64gb512ssd_v2',
    general_a_32c128gb1024ssd_v2: 'general_a_32c128gb1024ssd_v2',
    general_a_32c128gb2048ssd_v2: 'general_a_32c128gb2048ssd_v2',
    general_a_32c128gb512ssd_v2: 'general_a_32c128gb512ssd_v2',
    general_a_8c32gb1024ssd_v2: 'general_a_8c32gb1024ssd_v2',
    general_a_8c32gb2048ssd_v2: 'general_a_8c32gb2048ssd_v2',
    general_a_8c32gb256ssd_v2: 'general_a_8c32gb256ssd_v2',
    general_a_8c32gb512ssd_v2: 'general_a_8c32gb512ssd_v2',
    general_i_16c64gb1024ssd_v2: 'general_i_16c64gb1024ssd_v2',
    general_i_16c64gb2048ssd_v2: 'general_i_16c64gb2048ssd_v2',
    general_i_16c64gb256ssd_v2: 'general_i_16c64gb256ssd_v2',
    general_i_16c64gb512ssd_v2: 'general_i_16c64gb512ssd_v2',
    general_i_32c128gb1024ssd_v2: 'general_i_32c128gb1024ssd_v2',
    general_i_32c128gb2048ssd_v2: 'general_i_32c128gb2048ssd_v2',
    general_i_32c128gb512ssd_v2: 'general_i_32c128gb512ssd_v2',
    general_i_8c32gb1024ssd_v2: 'general_i_8c32gb1024ssd_v2',
    general_i_8c32gb2048ssd_v2: 'general_i_8c32gb2048ssd_v2',
    general_i_8c32gb256ssd_v2: 'general_i_8c32gb256ssd_v2',
    general_i_8c32gb512ssd_v2: 'general_i_8c32gb512ssd_v2',
};

export type StablePoolContract = GeneratedPoolStable;
export type BetaPoolContract = GeneratedPoolBeta;
export type PoolContract = BetaPoolContract;

export type StableHardwareProfileContract = GeneratedHardwareProfileStable;
export type BetaHardwareProfileContract = GeneratedHardwareProfileBeta;
export type HardwareProfileContract = BetaHardwareProfileContract;
export type ArchitectureTypeContract = GeneratedArchitectureTypeBeta;
export const ArchitectureTypeContract: UnionMap<ArchitectureTypeContract> = {
    x64: 'x64',
    Arm64: 'Arm64',
};
export type HibernateSupportContract = GeneratedHibernateSupportStable;
export type ImageReferenceContract = GeneratedImageReferenceStable;
export type LocalAdminStatusContract = GeneratedLocalAdminStatusStable;
export type PoolHealthStatusContract = GeneratedPoolHealthStatusStable;
export type StorageProfileContract = GeneratedStorageProfileStable;
